import { render, staticRenderFns } from "./TelemetriaPantalla.vue?vue&type=template&id=40652df6&"
import script from "./TelemetriaPantalla.vue?vue&type=script&lang=ts&"
export * from "./TelemetriaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('40652df6', component.options)
    } else {
      api.reload('40652df6', component.options)
    }
    module.hot.accept("./TelemetriaPantalla.vue?vue&type=template&id=40652df6&", function () {
      api.rerender('40652df6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Telemetria/Dashboard/TelemetriaPantalla.vue"
export default component.exports